import React from "react";
import { withTranslation } from "react-i18next";
import { LocalStorageService, ContractorService, CompanyService } from "../../../services";
import { ContractorsCatalogView } from "../../views";
import { ProfileValidator } from "../../../validators";


class ContractorsCatalogAction extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingView: false,
            token: '',
            url: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            typePersonDropDown: [],
            dateModified: '',
            titleBtnAdd: '',
            placeHolderSearch: '',
            titleColumnName: '',
            contractors: [],
            companies: [],
            selfEmail: '',
            companiesToClassified: [],
            logoFile: null,
            contractorRepseType: [],
            documents: []
        }
    }

    token = {};
    user = {}
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    contractorService = new ContractorService(this.url)
    companyService = new CompanyService(this.url);

    validator = ProfileValidator(this.props.t);
    paramsId = 0

    async componentDidMount() {
        this.toggleLoadingScreen(true);
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user");
        let urlArr = window.location.href.split("/");
        this.paramsId = Number(urlArr[urlArr.length - 1])
        let initialPerson = this.paramsId === 2 ? 9 : 7
        let titleBtnAdd = (this.paramsId && this.paramsId === 2) ? this.props.t("contractorsCatalogView-btn-add-provider") : this.props.t("contractorsCatalogView-btn-add-contractor")
        let placeHolderSearch = (this.paramsId && this.paramsId === 2) ? this.props.t("contractorsCatalogView-btn-search-provider") : this.props.t("contractorsCatalogView-btn-search-contractor")
        let titleColumnName = (this.paramsId && this.paramsId === 2) ? this.props.t("contractorsCatalogView-title-column-provider") : this.props.t("contractorsCatalogView-title-column-contractor")
        let selfEmail = this.user.userMetaData.userA3Cloud.email

        this.setState({
            user: this.user,
            token: this.token,
            url: this.url,
            titleBtnAdd,
            placeHolderSearch,
            titleColumnName,
            selfEmail,
            initialPerson
        })
        this.getContractPersonTypes()
        this.getContractors()
        this.getCompanies()
        this.getContractorsType()
    }

    toggleLoadingScreen = (value) => {
        this.setState({
            isLoadingView: value
        })
    }


    toggleErrorRequesting = (value, message, time, sendInbox) => {
        this.setState({
            showErrorRequesting: value,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (value, time, sendInbox) => {
        this.setState({
            showCompletedRequesting: value,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        });
    }

    //get contract person type
    getContractPersonTypes = async () => {
        let errorMessage = 'Ocurrió un error al consultar los tipos de personas'
        try {
            let contractorPersonType = await this.contractorService.getContractorsPerson(this.token)
            if (contractorPersonType && contractorPersonType.data && contractorPersonType.data.data && Number(contractorPersonType.status) === 200) {
                this.setState({
                    typePersonDropDown: contractorPersonType.data.data.contractor
                })
            }
        } catch (error) {
            console.log(error)
            this.toggleLoadingScreen(false)
            this.toggleErrorRequesting(true, errorMessage, 4000, true)
        }
    }

    getContractors = async () => {
        let typePerson = (this.paramsId && this.paramsId === 2) ? 'proveedores REPSE' : 'contratantes'
        let messageError = `Ocurrió un error al obtener a todos los ${typePerson}`
        let clientId = this.user.userMetaData.userMifirma.clientId;
        let classifierKey = (this.paramsId && this.paramsId === 1) ? 'contractorKey' : 'supplierRepseKey'

        try {
            let contractors = await this.contractorService.getContarctorsOrSupliersByClientIdAndKey(clientId, classifierKey, this.token)
            if (contractors && contractors.data && contractors.data.data && Number(contractors.data.statusCode) === 200) {
                let contractorsData = contractors.data.data.map((contractor) => {
                    let info = {}
                    info.id = contractor.id
                    info.name = contractor.name
                    info.status = contractor.active
                    info.date = contractor.formatedCreatedDate
                    info.company = contractor.company
                    info.updatedByUser = contractor.updatedByUser
                    info.logo = (contractor.logo) ? contractor.logo : ''
                    info.desactivationReason = (contractor.desactivationReason) ? contractor.desactivationReason : ''
                    info.typeContractor = (this.paramsId && this.paramsId === 1) ? 1 : 2
                    info.classifier = contractor.classifier
                    info.classifiers = contractor.classifiers
                    let country = contractor && contractor && contractor.contractorCountry ? contractor.contractorCountry : 'México'
                    info.country = country
                    info.contractorPersonTypeId = contractor.contractorPersonTypeId
                    info.rfc = contractor.rfc
                    info.curp = contractor.curp
                    info.contractorStreet = contractor.contractorStreet
                    info.contractorTownship = contractor.contractorTownship
                    info.contractorState = contractor.contractorState
                    info.contractorZipCode = contractor.contractorZipCode
                    return info
                })
                this.setState({
                    contractors: contractorsData
                })
                this.toggleLoadingScreen(false)
            } else {
                this.toggleLoadingScreen(false)
                this.toggleErrorRequesting(true, messageError, 4000, true)
            }
        } catch (error) {
            this.toggleLoadingScreen(false)
            this.toggleErrorRequesting(true, messageError, 4000, true)
        }
    }

    getContractorsType = async () => {
        let typeContractor = this.paramsId === 2 ? 'provider' : 'contractor'
        let errorMessage = `Ocurrio un error al obtener los tipos de contratantes`
        try {
            let contractorsTypes = await this.contractorService.getPersonTypeByAdditionalKeyGroup(typeContractor, this.token)
            let types = contractorsTypes.data.sort((a, b) => a.id - b.id)
            if (contractorsTypes.statusCode === 200 && contractorsTypes.data) {
                this.setState(
                    {
                        contractorsTypes: types
                    }
                )
            } else {
                this.toggleLoadingScreen(false)
                this.toggleErrorRequesting(true, errorMessage, 4000, true)
            }
        } catch (e) {
            this.toggleLoadingScreen(false)
            this.toggleErrorRequesting(true, errorMessage, 4000, true)
        }
    }

    getCompanies = async () => {
        let messageError = 'Ocurrió un error al consultar las empresas'
        try {
            let companies = await this.companyService.getCompanys(this.token)
            if (companies && companies.data.data && Number(companies.data.statusCode) === 200) {
                let allCompanies = [{
                    id: '0',
                    "name": 'Todas'
                }]
                let companiesToClassified = []
                companies.data.data.map((company) => {
                    let info = {}
                    info.id = company.company.id
                    info.name = company.company.companyName

                    if (company.company.status) {
                        allCompanies.push(info)
                        companiesToClassified.push(info)
                    }
                    return company
                })
                this.setState({
                    companies: allCompanies,
                    companiesToClassified
                })
            } else {
                this.toggleLoadingScreen(false)
                this.toggleErrorRequesting(true, messageError, 4000, true)
            }
        } catch (error) {
            this.toggleLoadingScreen(false)
            this.toggleErrorRequesting(true, messageError, 4000, true)
        }
    }

    getConractorsForService = async (backGridView, showCompleteModal = true) => {
        let typePerson = (this.paramsId && this.paramsId === 2) ? 'proveedores REPSE' : 'contratantes'
        let messageError = `Ocurrió un error al obtener a todos los ${typePerson}`
        let clientId = this.user.userMetaData.userMifirma.clientId;
        let classifierKey = (this.paramsId && this.paramsId === 1) ? 'contractorKey' : 'supplierRepseKey'
        try {
            let contractors = await this.contractorService.getContarctorsOrSupliersByClientIdAndKey(clientId, classifierKey, this.token)
            if (contractors && contractors.data && contractors.data.data && Number(contractors.data.statusCode) === 200) {
                let contractorsData = contractors.data.data.map((contractor) => {
                    let info = {}
                    info.id = contractor.id
                    info.name = contractor.name
                    info.status = contractor.active
                    info.date = contractor.formatedCreatedDate
                    info.company = contractor.company
                    info.updatedByUser = contractor.updatedByUser
                    info.logo = (contractor.logo) ? contractor.logo : ''
                    info.desactivationReason = (contractor.desactivationReason) ? contractor.desactivationReason : ''
                    info.typeContractor = (this.paramsId && this.paramsId === 1) ? 1 : 2
                    info.classifier = contractor.classifier
                    info.classifiers = contractor.classifiers
                    let country = contractor && contractor && contractor.contractorCountry ? contractor.contractorCountry : 'México'
                    info.country = country
                    info.contractorPersonTypeId = contractor.contractorPersonTypeId
                    info.rfc = contractor.rfc
                    info.curp = contractor.curp
                    info.contractorStreet = contractor.contractorStreet
                    info.contractorTownship = contractor.contractorTownship
                    info.contractorState = contractor.contractorState
                    info.contractorZipCode = contractor.contractorZipCode
                    return info
                })
                this.setState({
                    contractors: contractorsData
                })

                if (showCompleteModal) {
                    this.toggleLoadingRequesting(false)
                }
                this.toggleCompletedRequesting(true, 4000, false)
                setTimeout(() => {
                    backGridView()
                }, 4000)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(true, messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(true, messageError, 4000, false)
        }
    }

    setLogoFile = (logo) => {
        this.setState({
            logoFile: logo,
        })
    }

    contractorCompanyInsertDelete = async (contractorId, companyId, action, dataItem, value, mapCompaniesWhenOk) => {
        this.toggleLoadingRequesting(true)
        let errorAction = (action === 1) ? 'crear' : 'eliminar'
        let typePErson = (this.paramsId === 1) ? 'Contratante' : 'Proveedor'
        let messageError = `Ocurrió un error al ${errorAction} la relación del ${typePErson} con la compañia`
        try {
            let companyContractor = await this.contractorService.insertDeleteCompanyContractor(contractorId, companyId, action, this.token)
            if (companyContractor && companyContractor.data && Number(companyContractor.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                mapCompaniesWhenOk(dataItem, value)
                this.toggleCompletedRequesting(true, 4000, false)
            } else if (companyContractor && !companyContractor.data && Number(companyContractor.statusCode) === -5) {
                messageError = 'Ocurrió un error. El proveedor debe estar asignado a una compañía'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(true, messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(true, messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(true, messageError, 4000, false)
        }
    }

    contractorClassifierInsertDelete = async (contractorId, classifierId, action, dataItem, value, mapClassifiersWhenOk) => {
        this.toggleLoadingRequesting(true)
        this.toggleLoadingRequesting(true)
        let errorAction = (action === 1) ? 'crear' : 'eliminar'
        let typePErson = (this.paramsId === 1) ? 'Contratante' : 'Proveedor'
        let messageError = `Ocurrió un error al ${errorAction} la relación del ${typePErson} con la clasificador`

        try {
            let contractorClassfier = await this.contractorService.insertDeleteContractorClassifier(contractorId, classifierId, action, this.token)

            if (contractorClassfier && contractorClassfier.data && Number(contractorClassfier.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                mapClassifiersWhenOk(dataItem, value)
                this.toggleCompletedRequesting(true, 4000, false)
            } else if (contractorClassfier && !contractorClassfier.data && Number(contractorClassfier.statusCode) === -5) {
                messageError = 'Ocurrió un error. El proveedor debe estar asignado a una compañía'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(true, messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(true, messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(true, messageError, 4000, false)
        }
    }

    updateGrid = async (id) => {
        try {
            let getContractor = await this.contractorService.getContarctorByEmailAndClientId(id, this.token, true)
            return getContractor.contractor
        } catch (e) {
            console.log(e)
            this.toggleErrorRequesting(true, "", 3000)
        }
    }

    getContractorClientDocument = async (id) => {
        let typePerson = (this.paramsId === 1) ? 'Contratante' : 'Proveedor'
        let messageError = `Ocurrió un error al consultar los documentos del ${typePerson}`
        try {
            let contractorClientDocument = await this.contractorService.getContractorClientDocuments(id, this.token)
            if (contractorClientDocument && contractorClientDocument.data && contractorClientDocument.data.data && Number(contractorClientDocument.data.statusCode) === 200) {
                let allDocuments = contractorClientDocument.data.data.map((documento) => {
                    documento.name = (documento.clientDocument && documento.clientDocument.name) ? documento.clientDocument.name : ''
                    let uploadLabel = (documento.createdDate) ? `Cargado el ${documento.createdDate}` : ''
                    documento.uploaded = (documento.documentWasLoaded) ? uploadLabel : ''
                    return documento
                })

                let documents = allDocuments.filter((documento) => documento.documentWasLoaded === true)

                this.setState({
                    documents
                })
                this.toggleLoadingRequesting(false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(true, messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(true, messageError, 4000, false)
        }
    }

    render() {
        return (
            <ContractorsCatalogView
                {...this.state}
                history={this.props.history}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleLoadingScreen={this.toggleLoadingScreen}
                validator={this.validator}
                paramsId={this.paramsId}
                getConractorsForService={this.getConractorsForService}
                setLogoFile={this.setLogoFile}
                contractorCompanyInsertDelete={this.contractorCompanyInsertDelete}
                contractorClassifierInsertDelete={this.contractorClassifierInsertDelete}
                updateGrid={this.updateGrid}
                getContractorClientDocument={this.getContractorClientDocument}
            />
        )
    }
}

export default withTranslation()(ContractorsCatalogAction);
